// extracted by mini-css-extract-plugin
export default {"container":"styles_container__HIi5v","logo":"styles_logo__GXE1M"};